import React from "react";
import {Box, Stack, Text, View} from "@unibuddy/patron";

import {Flag} from "./Flag";

export type FlagField = {
    code?: string;
    name?: string;
};

export type CardAvatarProps = {
    url: string;
    alt: string;
    primaryFlag?: FlagField;
    secondaryFlag?: FlagField;
};

const BORDER_WIDTH = 2;
const AVATAR_IMAGE_SIZE = 108;
const AVATAR_CONTAINER_SIZE = AVATAR_IMAGE_SIZE + 2 * BORDER_WIDTH;

export const ContentDetailsAvatar = ({url, alt, primaryFlag, secondaryFlag}: CardAvatarProps) => {
    return (
        <Box flexShrink={0} position="relative">
            <Box
                w={AVATAR_CONTAINER_SIZE}
                h={AVATAR_CONTAINER_SIZE}
                bgColor="white"
                borderRadius="full"
                justifyContent="center"
                alignItems="center"
                display="flex"
            >
                <img
                    alt={alt}
                    src={url}
                    style={{
                        width: AVATAR_IMAGE_SIZE,
                        height: AVATAR_IMAGE_SIZE,
                        borderRadius: "50%",
                        objectFit: "cover",
                    }}
                />
            </Box>
            {(primaryFlag || secondaryFlag) && (
                <Box position="absolute" bottom={0} width="100%">
                    <Box display="flex" justifyContent="space-between" flexDirection="row-reverse">
                        {secondaryFlag && (
                            <Flag
                                alt={`Author's second country flag ${secondaryFlag.name}`}
                                countryCode={secondaryFlag.code}
                            />
                        )}
                        {primaryFlag && (
                            <Flag
                                alt={`Author's country flag ${primaryFlag.name}`}
                                countryCode={primaryFlag.code}
                            />
                        )}
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export function ContentDetailsHeader({authorName, authorDegree, avatar}) {
    return (
        <View flexDirection="row" alignItems="center" gap="small-medium">
            {avatar}
            <View h="100%" minH="100%" justifyContent="center">
                <Stack space="small">
                    <Text
                        size="large"
                        weight="600"
                        color={"var(--theme-primary)"}
                        style={{textDecoration: "underline"}}
                    >
                        {authorName}
                    </Text>
                    <Text size="small" truncate style={{textDecoration: "underline"}}>
                        {authorDegree}
                    </Text>
                </Stack>
            </View>
        </View>
    );
}
